var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ExerciseComponent',{attrs:{"user-i-d":_vm.$route.params.id,"amount":parseInt(_vm.$route.query.amountp)}})}
var staticRenderFns = []

export { render, staticRenderFns }